module.exports = __webpack_public_path__ + "img/balloon-peace.7b8d2f80.png";